import { useEffect, useState } from "react";

import { useAuth } from "../../hooks";
import { IStaffDepartment } from "../../interfaces-and-types";

import { HeaderMenuDropDown } from "../HeaderMenuDropDown";
import departmentIcon from "../../assets/icons/shop.svg";
import { AddNewAccountDropDown } from "./AddNewAccountDropDown";
import { SearchBar } from "../SearchBar";
import { DepartmentView } from "./DepartmentView";

interface IMerchantSwitcherProps {
  isOpenBusinessesDropDown: boolean;
  setOpenBusinessesDropDown: React.Dispatch<React.SetStateAction<boolean>>;
  openCreateNewModal: () => void;
  // search: string | null; // this causes re-rendering on each keystroke
  // setSearch: (search: string) => void;
}

export const MerchantSwitcherDropdown = ({
  isOpenBusinessesDropDown,
  openCreateNewModal,
  setOpenBusinessesDropDown,
  /* search,
   setSearch, */
}: IMerchantSwitcherProps) => {
  const { active_tenant_id, setActiveTenantId, signOut, staff_departments } =
    useAuth();
    
    const [search, setSearch] = useState<
    string | null
  >(null);

  const [activeMerchantAccount, setActiveMerchantAccount] =
    useState<IStaffDepartment | null>(
      active_tenant_id && staff_departments
        ? staff_departments.find((d) => d.merchant_id === active_tenant_id) ||
            null
        : null
    );

  useEffect(() => {
    if (active_tenant_id !== activeMerchantAccount?.merchant_id) {
      const activeTenant =
        active_tenant_id && staff_departments
          ? staff_departments.find((d) => d.merchant_id === active_tenant_id) ||
            null
          : null;

      setActiveMerchantAccount(activeTenant);
    }
  }, [staff_departments, activeMerchantAccount?.merchant_id, active_tenant_id]);

  const setActiveTenantInContext = (item: IStaffDepartment) => {
    setActiveTenantId(item.merchant_id);
    // refreshBusinesses();
  };

  const staff_departments_with_active_removed =
    staff_departments?.filter(
      (item) => item.merchant_id !== active_tenant_id
    ) ?? [];

  const searchFilteredStaffDepartments =
    staff_departments_with_active_removed.filter(
      (d) =>
        !search ||
        d.merchant_name.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
        d.merchant_id.indexOf(search) >= 0
    );

  return (
    <HeaderMenuDropDown<IStaffDepartment>
      headerContainerClass="header-menu-dropdown--container"
      headerDropdownContentClass="header-menu-dropdown--content user-businesses-dropdown align-self--end"
      className="header-menu-trigger--button"
      items={searchFilteredStaffDepartments}
      onSelect={(item) => {
        setActiveTenantInContext(item);
        setSearch("");
      }}
      ignoreClickOutside
      open={isOpenBusinessesDropDown}
      setOpen={setOpenBusinessesDropDown}
      renderItem={(item) => <DepartmentView {...item} />}
      renderInButton={
        <div
          title={activeMerchantAccount?.merchant_name || "..."}
          className="account-select--value flex-container align-items--start"
        >
          <img
            src={activeMerchantAccount?.merchant_logo || departmentIcon}
            alt="business"
            className="department-icon"
          />
          <span className="active-department-name truncate-text--ellipsis">
            {activeMerchantAccount?.merchant_name || "..."}
          </span>
        </div>
      }
      renderBefore={
        <SearchBar
          name="search-businesses"
          placeholder="Search your businesses..."
          onChange={(e: any) => {
            setSearch(e.target.value);
          }}
          onClear={() => setSearch("")}
          value={search}
          key={"search-businesses"}
        />
      }
      renderAfter={
        <AddNewAccountDropDown openAddNewAccountModal={openCreateNewModal} />
      }
      headerMenuDropdownContentItemClass="flex-container header-menu-dropdown-content-item"
      headerMenuDropdownButton={true}
    />
  );
};
